import { StandardEvents } from '@shopify/events';
if (!customElements.get('modanie-description-images')) {
  customElements.define('modanie-description-images', class extends HTMLElement {
    connectedCallback() {
      this.sequence = 0;
      this.onSelect = async (event) => {
        if (!(event.target instanceof Element) || event.target.closest('product-card, quick-add-dialog')) return;
        const sequence = ++this.sequence;
        try {
          const { detail } = await event.promise;
          if (!this.isConnected || sequence !== this.sequence || String(detail?.productId) !== this.dataset.productId) return;
          let next = detail.html?.querySelector('modanie-description-images');
          if (!next && detail.resource?.id) {
            const url = new URL(location.href);
            url.searchParams.set('variant', detail.resource.id);
            url.searchParams.set('section_id', this.dataset.sectionId);
            const response = await fetch(url);
            if (!response.ok) return;
            next = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('modanie-description-images');
          }
          if (next && this.isConnected && sequence === this.sequence) this.replaceChildren(...next.childNodes);
        } catch (error) {
          if (error.name !== 'AbortError') console.warn('Description images could not update', error);
        }
      };
      document.addEventListener(StandardEvents.productSelect, this.onSelect);
    }
    disconnectedCallback() {
      this.sequence++;
      document.removeEventListener(StandardEvents.productSelect, this.onSelect);
    }
  });
}